import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=a8d4a0b8"
import script from "./tongji.vue?vue&type=script&lang=js"
export * from "./tongji.vue?vue&type=script&lang=js"
import style0 from "./tongji.vue?vue&type=style&index=0&id=a8d4a0b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports